export const copyLinkLabelKey = 'Omnichannel.Start.Alternatives.Qr.CopyLink'

export const linkCopiedLabelKey = 'Omnichannel.Start.Alternatives.Qr.LinkCopied'
